import {ChangeDetectorRef, Component, ElementRef, OnChanges, OnInit, Renderer2, SimpleChanges} from '@angular/core';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {LabelFieldConfig} from '../label-field.config';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {AbstractControl} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FieldConfig} from '../../../dynamic-field/field.config';

@UntilDestroy()
@Component({
    selector: 'mydocma-form-label-field',
    templateUrl: './label-field.component.html',
    styleUrls: ['./label-field.component.scss']
})
export class LabelFieldComponent extends BaseFieldComponent<LabelFieldConfig> implements OnChanges, OnInit {
    public fieldToBind: { control: AbstractControl, config: FieldConfig<any> }
        = {control: null, config: null}
    public readonly staticCssClass = 'mydocma-label-field';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher, element, renderer);
    }

    public onLabelClick() {
        if ((this.fieldWrapper.config as LabelFieldConfig).onLabelClick) {
            (this.fieldWrapper.config as LabelFieldConfig).onLabelClick();
        }
        super.onControlClick();
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnInit() {
        super.ngOnInit();
        this.checkForBindedField();
        this.fieldWrapper.onUpdated.pipe(untilDestroyed(this))
            .subscribe((value) => {
                this.checkForBindedField();
            });
    }

    private checkForBindedField() {
        const fieldToBind = this.fieldWrapper.config?.attachToField?.name;
        const formGroup = this.dynamicFormService?.formGroup;
        this.fieldToBind.control = formGroup?.get(fieldToBind);
        if (fieldToBind && this.fieldToBind.control) {
            this.fieldToBind.config = this.dynamicFormService.getFieldConfig(fieldToBind);
        } else {
            this.fieldToBind.config = null;
            this.fieldToBind.control = null
        }
    }
}
